
import { ReactNode, useEffect, useRef } from "react";
import { createFastContext } from "../../../contexts/createFastContext";
import { getParamsWeatherOfOp } from "../../../pages/PlanOperationPage/util";
import { OpService } from "../../../util/services/operation";
import { InfoMode, OPERATION_TYPE } from "../../../util/varibles/constants";
import { showErrorResponse } from "../../../util/varibles/global";
import { IActivityLog, IOperation, IOperation2 } from "../../../util/varibles/interface";

const getWeather = (data: IOperation2): ReturnType<typeof OpService.getWeather> => {
    const { activity_log, operation: { tenant_id } } = data;
    const operation_type = data.operation.operation_type as OPERATION_TYPE;
    if (operation_type === OPERATION_TYPE.UNAVAILABLE) {
        throw new Error("Invalid operation");
    }
    const params = getParamsWeatherOfOp(data.operation, { operation_type, tenant_id, activity_log });

    return OpService.getWeather(params)
}

const InitData: React.FC<{ data?: IOperation2 }> = ({ data }) => {
    const setRef = useRef(setPopupOpInfo());
    useEffect(() => {
        if (data) {
            const set = setRef.current;
            set({ weather: { loading: true, data: [] } })
            getWeather(data)
                .then(rs => {
                    const { weather, typical_condition, ...args } = rs;
                    const state = { weather: { loading: false, data: { weather, typical_condition }, } };
                    if (Object.keys(args).length > 0) {
                        set(({ data: prev }) => ({ ...state, data: prev ? { ...prev, operation: { ...prev.operation, ...args } } : prev }))
                    } else {
                        set(state);
                    }
                })
                .catch((error: any) => {
                    set({ weather: { loading: false, data: [], } })
                    showErrorResponse('Get weather failed', error);
                })
        }
    }, [data]);

    return null
}

interface IState {
    infoMode: InfoMode
    weather: {
        loading: boolean
        data: any
    }

    data?: IOperation
    spOps?: IOperation[]
    isEdit?: boolean
    isOwn: boolean
    isApprove: boolean

    onClose?(): void

    updateOperation(payload: { data: IOperation, isCheck?: boolean }): void
}

const { Provider, useStore: usePopupOpInfo, setStore: setPopupOpInfo, getStore: getPopupOpInfo, callEvent: callEventPopupOpInfo } = createFastContext<IState, {
    updateActivityLog(activity_log: IActivityLog[]): void,
    updateNote(note: string): void,
    changeState(params: any): void
}>({
    infoMode: InfoMode.PLAN,
    weather: {
        loading: false,
        data: []
    },
    isOwn: false,
    isApprove: false,
    updateOperation: () => null
});

const PopupOpInfoProvider = ({ children, ...props }: {
    children: ReactNode,
} & Partial<IState>) => {

    return <Provider
        props={props}
        event={{
            updateActivityLog: (activity_log, { get, set }) => {
                const { updateOperation, data } = get();
                if (!data)
                    return;
                set({ data: { ...data, activity_log } })
                updateOperation({ data: { ...data, activity_log } });
            },
            updateNote: (note, { get }) => {
                const { updateOperation, data } = get();
                if (!data)
                    return;
                updateOperation({ data: { ...data, operation: { ...data.operation, note } }, isCheck: false });
            },
            changeState: (params, { get }) => {
                const { updateOperation, data, onClose } = get();
                if (!data)
                    return;
                OpService.updateStatus(params)
                    .then((rs: any) => {
                        const { activity_log, operation } = rs;
                        updateOperation({ data: { ...data, operation: { ...data.operation, ...operation }, activity_log } });
                    })
                    .catch((error) => {
                        showErrorResponse('Update status failed', error);
                    })
                onClose?.();
            }
        }}
    >
        <InitData data={props.data as IOperation2} />
        {children}
    </Provider>
}


export { callEventPopupOpInfo, getPopupOpInfo, PopupOpInfoProvider, setPopupOpInfo, usePopupOpInfo };
